import React from 'react'

import {priceFormatter} from '../../../helpers/Numbers'

const Keywords = ({car}) => {

    const featuredOptions = (car) => {

        const pills = [];
        const pills_max_count = 5;


        /**
         * Configure what the featured conditions should be here..
         */

    //     const getIcon = () => {
	// 	if (['Laddhybrid', 'Hybrid'].includes(car.engineBaseType)) {
	// 		return <span role="img" aria-label="hybrid" className="eco icon-plugin"></span>
	// 	} else if (['Mildhybrid', 'Elhybrid'].includes(car.engineBaseType)) {
	// 		return <span role="img" aria-label="el" className="eco icon-leaf"></span>
	// 	}
	// 	return;
	// }

        // Not diesel nor bensin ≈ Miljöbil?
        if(['Laddhybrid', 'Hybrid'].includes(car.engineBaseType)){
            pills.push({ order: 1, value: car.engineBaseType, icon:'environment'});
        } else if(['Mildhybrid', 'Elhybrid'].includes(car.engineBaseType)){
            pills.push({ order: 1, value: car.engineBaseType, icon:'environment'});
            // pills.push({ order: 1, value: car.engineBaseType, icon:'environment_red'});
        } else {
            pills.push({ order: 5, value: car.engineBaseType, icon: 'engine'});
        }
        
        // if(  car.fuelType === 'El' ){
        //     pills.push({ order: 1, value: car.fuelType, icon:'environment'});
        // } else if(  ! ['Diesel', 'Bensin'].includes(car.fuelType) ){
        //     pills.push({ order: 1, value: car.fuelType, icon:'environment_red'});
        // } else {
        //     pills.push({ order: 5, value: car.fuelType, icon: 'engine'});
        // }

        // Range in electric mode
        if(  car.enhancedProperties.hasOwnProperty('electricalRangeNEDC') ){
            let {value, unit } = car.enhancedProperties.electricalRangeNEDC;
            pills.push({ order: 2, value: value + ' ' + unit, icon:'lightning'});
        }

        // Basics
        pills.push({ order: 5, value: car.gearboxType, icon:'gearbox'});
        pills.push({ order: 5, value: car.modelYear, icon: 'calendar'});
        pills.push({ order: 5, value: priceFormatter( car.mileage, ' mil'), icon: 'speedometer'});


        return sort(pills, pills_max_count);
    }

    const otherOptions = (car) => {

        /**
         * Configure what the other conditions should be here..
         */


        const pills = [];
        const pills_max_count = 8;

        if( car.enhancedProperties.hasOwnProperty('laneAssistance') ) {
            let { name } = car.enhancedProperties.laneAssistance;
            pills.push({ order: 3, value: name });
        }
        
        if( car.properties.drivingWheel === 'Fyrhjulsdrift' ) {
            pills.push({ order: 2, value: 'Fyrhjulsdrift' });
        }
        if( Array.from(car.options ?? []).includes('Backkamera') ) {
            pills.push({ order: 2, value: 'Backkamera' });
        }

        return sort(pills, pills_max_count);
    }

    const sort = (pills, max) => {

        pills.sort( function(a,b) {
            if( a.order > b.order )
                return 1
            else if( a.order < b.order)
                return -1  
            return 0;
        }).slice(0, max);

        return pills;
    }

    return (
        <>
            <div className="featured">
                { featuredOptions(car).map(function(option, index){
                    return (
                        <span key={index}><span className={ `icon icon-${option.icon}` }></span>{ option.value }</span>
                    )
                }) }
            </div>
            <div className="pills">
                { otherOptions(car).map(function(option, index){
                    return (
                        <span key={index} className="pill">{ option.value }</span>
                    )
                }) }
            </div>
        </>
    )

}

export default Keywords